import { Helmet } from "react-helmet-async";
import { useLang } from "../i18n";

export const Seo = ({ title, description, path, jsonLd }) => {
  const { lang, data } = useLang();
  const baseUrl = data.SITE.url;
  const fullTitle = title
    ? `${title} | Le dolci Dimore`
    : lang === "en"
      ? "Le dolci Dimore | B&B in an 18th-century villa near Mantua"
      : "Le dolci Dimore | B&B in villa del Settecento vicino a Mantova";
  const itUrl = `${baseUrl}${path || "/"}`;
  const enUrl = `${baseUrl}/en${!path || path === "/" ? "" : path}`;
  const canonical = lang === "en" ? enUrl : itUrl;
  return (
    <Helmet htmlAttributes={{ lang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <link rel="alternate" hreflang="it" href={itUrl} />
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="x-default" href={itUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={lang === "en" ? "en_GB" : "it_IT"} />
      <meta property="og:locale:alternate" content={lang === "en" ? "it_IT" : "en_GB"} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};
